import type { DataTableColumn } from '@/components/custom/erp';
import type { ThuChi } from '@/types/schemas';

export const thuChiColumns: DataTableColumn<ThuChi>[] = [
  {
    field: 'ma_thu_chi',
    headerName: 'Mã thu chi',
    width: 120,
    renderCell: params => {
      const level = params.row.level || 0;
      const value = String(params.value ?? '');
      if (level === 0) {
        return <span className='font-bold'>{value}</span>;
      }
      if (level >= 2) {
        return <span className='italic'>{value}</span>;
      }
      return <span>{value}</span>;
    }
  },
  {
    field: 'ten_thu_chi',
    headerName: 'Tên thu chi',
    width: 250,
    renderCell: params => {
      const level = params.row.level || 0;
      const value = String(params.value ?? '');
      if (level === 0) {
        return <span className='font-bold'>{value}</span>;
      }
      if (level >= 2) {
        return <span className='italic'> - {value}</span>;
      }
      return <span className='font-medium'>{value}</span>;
    }
  },
  {
    field: 'ma_cha',
    headerName: 'Mã cha',
    width: 140,
    renderCell: params => {
      return <span>{params.row.ma_cha_data?.ma_thu_chi || ''}</span>;
    }
  },
  {
    field: 'trang_thai',
    headerName: 'Trạng thái',
    width: 150,
    renderCell: params => {
      switch (params.row.trang_thai) {
        case 1:
          return '1. Còn sử dụng';
        case 0:
          return '0. Không sử dụng';
        default:
          return '';
      }
    }
  }
];

export const thuChiSearchColumns: DataTableColumn<ThuChi>[] = [
  { field: 'ma_thu_chi', headerName: 'Mã thu chi', width: 120 },
  { field: 'ten_thu_chi', headerName: 'Tên thu chi', width: 250 }
];

// Keep old name for compatibility with other files until they are updated
export const feeColumns = thuChiColumns;
